module.exports = __webpack_public_path__ + "img/5-2.6b73c477.png";